import { Rocket } from 'lucide-react'
import { Modal } from '@/components/ui/Modal'
import { Button } from '@/components/ui/Button'
import { DatetimeLocalField } from '@/components/Deals/DealDetailPanel/DatetimeLocalField'
import { MeetingTypeSelector } from '@/components/Deals/DealDetailPanel/MeetingTypeSelector'
import { isDirectProposalLeadConvert } from '@/components/Deals/DealDetailPanel/meetingTypeOptions'
import type { MeetingTypeValue } from '@/components/Deals/DealDetailPanel/meetingTypeOptions'
import type { CloserLeadConvertTarget } from '@/hooks/useCloserLeadConvertModal'

type Props = {
  open: boolean
  target: CloserLeadConvertTarget | null
  dataHora: string
  tipo: MeetingTypeValue
  submitting: boolean
  onClose: () => void
  onDataHoraChange: (value: string) => void
  onTipoChange: (value: MeetingTypeValue) => void
  onSubmit: () => void
}

export function ConvertLeadToDealModal({
  open,
  target,
  dataHora,
  tipo,
  submitting,
  onClose,
  onDataHoraChange,
  onTipoChange,
  onSubmit,
}: Props) {
  const empresa = target?.empresa?.trim() || 'Lead'
  const contato = target?.contato?.trim()
  const directProposal = isDirectProposalLeadConvert(tipo)

  return (
    <Modal
      open={open}
      onClose={onClose}
      title='Abrir negociação'
      description={
        directProposal
          ? 'Elabore a proposta até a data da apresentação.'
          : 'Agende a reunião — deal entra em Reunião Agendada.'
      }
      size='xl'
      stackPriority='high'
      bodyClassName='p-4 md:p-5'
      footer={
        <div className='flex justify-end gap-3'>
          <Button variant='ghost' size='sm' onClick={onClose} disabled={submitting}>
            Cancelar
          </Button>
          <Button
            variant='primary'
            size='sm'
            icon={<Rocket size={14} />}
            loading={submitting}
            onClick={onSubmit}
            className='bg-[var(--color-success)] text-white hover:bg-[var(--color-success)] hover:opacity-90'
          >
            {directProposal ? 'Abrir em Elaborar Proposta' : 'Criar negociação'}
          </Button>
        </div>
      }
    >
      <div className='grid gap-4 md:grid-cols-[minmax(0,1fr)_minmax(0,1.1fr)] md:items-start'>
        <div className='space-y-3'>
          <div className='rounded-lg border border-white/[0.06] bg-white/[0.03] px-3 py-2'>
            <p className='text-sm font-medium text-text-primary'>{empresa}</p>
            {contato ? <p className='text-xs text-text-muted'>{contato}</p> : null}
          </div>

          <MeetingTypeSelector
            value={tipo}
            context='leadConvert'
            variant='compact'
            onChange={onTipoChange}
          />
        </div>

        <DatetimeLocalField
          value={dataHora}
          attention
          openOnMount
          aria-invalid={!dataHora}
          placeholder={
            directProposal
              ? 'Data da reunião de apresentação'
              : 'Toque para escolher data e hora'
          }
          onChange={onDataHoraChange}
        />
      </div>
    </Modal>
  )
}

export default ConvertLeadToDealModal
